import { Component } from '@angular/core';
import { JobsIngestBatchEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Ingest Batches') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-jobsingestbatch-form',
    templateUrl: './jobsingestbatch.form.component.html'
})
export class JobsIngestBatchFormComponent extends BaseFormComponent {
    public record!: JobsIngestBatchEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

